import { Icon } from '@iconify/react';
import { useRef, useState, useContext } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';
import personFill from '@iconify/icons-eva/person-fill';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
// material
import { alpha } from '@mui/material/styles';
import { Button, Box, Divider, MenuItem, Typography, Avatar, IconButton } from '@mui/material';
// components
import MenuPopover from '../../components/MenuPopover';
import AuthContext from '../../context/AuthContext';
// ----------------------------------------------------------------------

export default function AccountPopover({ menu }) {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [t, i18n] = useTranslation();

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const { user, logoutUser } = useContext(AuthContext);
  const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
  const userDetails = JSON.parse(localStorage.getItem('user'));
  const pic = `${API_ENDPOINT}${userDetails.photo}`;

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            }
          })
        }}
      >
        <Avatar src={pic} alt={userDetails.username} />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography
            style={{
              color: 'grey',
              fontSize: '17px',
              fontFamily: 'Oregano, cursive',
              fontWeight: 500
            }}
            noWrap
          >
            {userDetails.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {menu.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              style={{
                margin: 5,
                width: 20,
                height: 20,
                color: 'grey'
              }}
            />

            <Typography
              style={{
                color: 'grey',
                fontSize: '17px',
                fontFamily: 'Oregano, cursive',
                fontWeight: 500
              }}
            >
              {t(option.label)}
            </Typography>
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            style={{ backgroundColor: '#f78181', color: 'white' }}
            onClick={logoutUser}
            fullWidth
          >
            {t('Sedéconnecter')}
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
